(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-contact-launcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hh-contact-launcher')) {
    class ContactLauncher extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.details = this.querySelector('[data-contact-details]');
        this.chatButton = this.querySelector('[data-open-shopify-chat]');

        this.details.addEventListener('toggle', () => {
          if (this.details.open) {
            window.requestAnimationFrame(() => this.positionShopifyChatActivator());
          } else {
            this.hideShopifyChatActivator();
          }
        });

        window.addEventListener('resize', () => {
          if (this.details.open) this.positionShopifyChatActivator();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.details.querySelector('summary').focus();
          }
        });

        this.chatButton.addEventListener('click', () => {
          this.connectShopifyChat();
          const activator = this.getShopifyChatActivator();

          this.details.open = false;
          if (activator) activator.click();
        });

        customElements.whenDefined('shopify-chat').then(() => this.connectShopifyChat());

        this.chatObserver = new MutationObserver(() => {
          if (this.connectShopifyChat()) this.chatObserver.disconnect();
        });
        this.chatObserver.observe(document.documentElement, { childList: true, subtree: true });
      }

      connectShopifyChat() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || !chat.shadowRoot) return false;

        const runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
        const targetRoot = runtime ? runtime.shadowRoot : chat.shadowRoot;
        if (!targetRoot) return false;

        const activator = targetRoot.querySelector('.activator');
        if (!activator) return false;

        if (!targetRoot.querySelector('[data-hh-hide-chat-activator]')) {
          const style = document.createElement('style');
          style.setAttribute('data-hh-hide-chat-activator', '');
          style.textContent = '.activator { display: none !important; }';
          targetRoot.appendChild(style);
        }

        if (this.observedChat !== chat) {
          if (this.chatStateObserver) this.chatStateObserver.disconnect();

          this.observedChat = chat;
          this.chatStateObserver = new MutationObserver(() => {
            this.syncWithShopifyChat();
            window.requestAnimationFrame(() => this.connectShopifyChat());
          });
          this.chatStateObserver.observe(chat, { attributes: true, attributeFilter: ['open'] });
        }

        this.syncWithShopifyChat();

        if (this.details.open) this.positionShopifyChatActivator();

        return true;
      }

      getShopifyChatActivator() {
        const chat = document.querySelector('shopify-chat');
        if (!chat || !chat.shadowRoot) return null;

        const runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
        const targetRoot = runtime && runtime.shadowRoot ? runtime.shadowRoot : chat.shadowRoot;

        return targetRoot.querySelector('.activator');
      }

      syncWithShopifyChat() {
        const chat = document.querySelector('shopify-chat');
        const chatIsOpen = chat ? chat.hasAttribute('open') : false;

        this.classList.toggle('hh-contact-launcher--chat-open', chatIsOpen);
        if (chatIsOpen) this.details.open = false;
      }

      positionShopifyChatActivator() {
        const activator = this.getShopifyChatActivator();
        if (!activator || !this.chatButton) return;

        this.style.setProperty('z-index', '2147482999', 'important');

        const targetRoot = activator.getRootNode();
        const hidingStyle = targetRoot.querySelector('[data-hh-hide-chat-activator]');
        if (hidingStyle) hidingStyle.remove();

        const rect = this.chatButton.getBoundingClientRect();
        activator.style.setProperty('display', 'grid', 'important');
        activator.style.setProperty('position', 'fixed', 'important');
        activator.style.setProperty('inset', 'auto', 'important');
        activator.style.setProperty('left', `${rect.left}px`, 'important');
        activator.style.setProperty('top', `${rect.top}px`, 'important');
        activator.style.setProperty('width', `${rect.width}px`, 'important');
        activator.style.setProperty('height', `${rect.height}px`, 'important');
        activator.style.setProperty('margin', '0', 'important');
        activator.style.setProperty('opacity', '0', 'important');
        activator.style.setProperty('pointer-events', 'auto', 'important');
        activator.style.setProperty('z-index', '2147483647', 'important');
        activator.setAttribute('aria-label', 'Live chat');
        activator.setAttribute('tabindex', '-1');

        if (this.positionedActivator !== activator) {
          this.positionedActivator = activator;
          activator.addEventListener('click', () => {
            this.details.open = false;
            window.setTimeout(() => this.hideShopifyChatActivator(), 0);
          });
        }
      }

      hideShopifyChatActivator() {
        const activator = this.positionedActivator || this.getShopifyChatActivator();
        if (!activator) return;

        this.style.removeProperty('z-index');

        ['display', 'position', 'inset', 'left', 'top', 'width', 'height', 'margin', 'opacity', 'pointer-events', 'z-index'].forEach((property) => {
          activator.style.removeProperty(property);
        });
        activator.setAttribute('aria-label', 'Support');
        activator.removeAttribute('tabindex');

        const targetRoot = activator.getRootNode();
        if (!targetRoot.querySelector('[data-hh-hide-chat-activator]')) {
          const style = document.createElement('style');
          style.setAttribute('data-hh-hide-chat-activator', '');
          style.textContent = '.activator { display: none !important; }';
          targetRoot.appendChild(style);
        }
      }
    }

    customElements.define('hh-contact-launcher', ContactLauncher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class HHCustomerReviews {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-hh-review-viewport]');
      this.track = root.querySelector('.hh-customer-reviews__track');
      this.previous = root.querySelector('[data-hh-review-previous]');
      this.next = root.querySelector('[data-hh-review-next]');
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.viewport.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.update());
      root.querySelectorAll('[data-hh-review-toggle]').forEach((button) => this.prepareToggle(button));
      this.update();
    }

    prepareToggle(button) {
      const copy = button.previousElementSibling;
      button.hidden = copy.scrollHeight <= copy.clientHeight + 2;
      button.addEventListener('click', () => {
        const expanded = copy.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? button.dataset.hhReviewLess : button.dataset.hhReviewMore;
      });
    }

    step() {
      const card = this.track.querySelector('.hh-customer-review');
      if (!card) return this.viewport.clientWidth;
      return card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
    }

    move(direction) {
      this.viewport.scrollBy({ left: this.step() * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
      this.previous.disabled = this.viewport.scrollLeft <= 2;
      this.next.disabled = this.viewport.scrollLeft >= maximum - 2;
    }

    update() {
      this.root.querySelectorAll('[data-hh-review-toggle]').forEach((button) => {
        if (button.getAttribute('aria-expanded') !== 'true') {
          button.hidden = button.previousElementSibling.scrollHeight <= button.previousElementSibling.clientHeight + 2;
        }
      });
      this.updateArrows();
    }
  }

  const initializeHHCustomerReviews = (container = document) => {
    container.querySelectorAll('[data-hh-review-carousel]').forEach((root) => {
      if (root.dataset.hhReviewReady === 'true') return;
      root.dataset.hhReviewReady = 'true';
      new HHCustomerReviews(root);
    });
  };

  initializeHHCustomerReviews();
  document.addEventListener('shopify:section:load', (event) => initializeHHCustomerReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-judge-me-reviews"] && !Shopify.designMode) return;
  try {
    
  const enhanceHHJudgeReviews = (root) => {
    root.querySelectorAll('.jdgm-card').forEach((card) => {
      const reviewText = card.querySelector('.jdgm-text');
      const source = reviewText?.querySelector('p');
      if (reviewText && source && reviewText.dataset.hhReviewStructured !== 'true') {
        const body = source.textContent.trim().replace(/\s+/g, ' ');
        if (body) {
          const description = document.createElement('p');

          description.className = 'hh-judge-review-description';
          description.textContent = body;

          reviewText.replaceChildren(description);
          reviewText.dataset.hhReviewStructured = 'true';
        }
      }

      const reviewer = card.querySelector('.jdgm-reviewer-info');
      const reviewerName = card.querySelector('.jdgm-reviewer-name');
      if (reviewer && reviewerName) {
        const initials = reviewerName.textContent
          .trim()
          .split(/\s+/)
          .filter(Boolean)
          .slice(0, 2)
          .map((word) => word.charAt(0).toUpperCase())
          .join('');
        reviewer.dataset.initials = initials;
      }

      const verified = card.querySelector('.jdgm-reviewer-verified-icon');
      if (verified && !verified.querySelector('.hh-judge-verified-copy')) {
        const label = document.createElement('span');
        label.className = 'hh-judge-verified-copy';
        label.textContent = root.dataset.verifiedLabel;
        verified.append(label);
      }
    });
  };

  document.querySelectorAll('[data-hh-judge-reviews]').forEach((root) => {
    enhanceHHJudgeReviews(root);
    const observer = new MutationObserver(() => enhanceHHJudgeReviews(root));
    observer.observe(root, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-product-tabs"] && !Shopify.designMode) return;
  try {
    
  const formatHHProductMoney = (amount) => {
    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency
    }).format(Number(amount) / 100);
  };

  document.addEventListener('click', (event) => {
    const tabButton = event.target.closest('[data-hh-tab-button]');

    if (tabButton) {
      const section = tabButton.closest('[data-hh-product-tabs]');
      const buttons = Array.from(section.querySelectorAll('[data-hh-tab-button]'));
      const panels = Array.from(section.querySelectorAll('[data-hh-tab-panel]'));

      buttons.forEach((button) => {
        const isActive = button === tabButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tabButton.getAttribute('aria-controls');
      });
    }

    const loadMoreButton = event.target.closest('[data-hh-load-more]');

    if (loadMoreButton) {
      const panel = loadMoreButton.closest('[data-hh-tab-panel]');
      const pageSize = Number(loadMoreButton.dataset.pageSize) || 8;
      const hiddenCards = Array.from(panel.querySelectorAll('.hh-product-card--hidden'));

      hiddenCards.slice(0, pageSize).forEach((card) => card.classList.remove('hh-product-card--hidden'));

      if (panel.querySelectorAll('.hh-product-card--hidden').length === 0) {
        loadMoreButton.hidden = true;
      }
    }

    const quickViewButton = event.target.closest('[data-hh-quick-view]');

    if (quickViewButton) {
      const dialog = document.getElementById(quickViewButton.getAttribute('aria-controls'));

      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    const quantityButton = event.target.closest('[data-hh-quantity-button]');

    if (quantityButton) {
      const quantity = quantityButton.closest('.hh-product-dialog__quantity');
      const input = quantity.querySelector('[data-hh-quantity-input]');
      const step = Number(input.step) || 1;
      const minimum = Number(input.min) || 1;
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const current = Number(input.value) || minimum;
      const direction = quantityButton.getAttribute('data-hh-quantity-button') === 'increase' ? 1 : -1;

      input.value = Math.min(maximum, Math.max(minimum, current + (step * direction)));
    }

    const dialog = event.target.closest('[data-hh-product-dialog]');

    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });

  document.addEventListener('change', (event) => {
    const sortSelect = event.target.closest('[data-hh-product-sort]');

    if (sortSelect) {
      sortSelect.form.submit();
      return;
    }

    const optionInput = event.target.closest('[data-hh-option-value]');

    if (!optionInput) return;

    const form = optionInput.closest('.hh-product-dialog__form');
    const dialog = optionInput.closest('[data-hh-product-dialog]');
    const option = optionInput.closest('[data-hh-option-position]');
    const currentValue = option.querySelector('[data-hh-option-current]');
    const selectedInputs = Array.from(form.querySelectorAll('[data-hh-option-value]:checked')).sort((a, b) => {
      return Number(a.dataset.position) - Number(b.dataset.position);
    });
    const selectedValues = selectedInputs.map((input) => input.value);
    const variantsElement = dialog.querySelector('[data-hh-variants]');
    const variants = JSON.parse(variantsElement.textContent);
    const variant = variants.find((item) => {
      return item.options && item.options.every((value, index) => value === selectedValues[index]);
    });
    const variantInput = form.querySelector('[data-hh-variant-id]');
    const price = dialog.querySelector('[data-hh-dialog-price]');
    const addButton = form.querySelector('[data-hh-add-to-cart]');

    currentValue.textContent = optionInput.value;

    if (!variant) {
      variantInput.value = '';
      addButton.disabled = true;
      addButton.textContent = addButton.dataset.soldOutLabel;
      return;
    }

    variantInput.value = variant.id;
    price.textContent = formatHHProductMoney(variant.price);
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;

    const image = dialog.querySelector('[data-hh-dialog-image]');
    const variantImage = variant.featured_image && (variant.featured_image.src || variant.featured_image);

    if (image && typeof variantImage === 'string') {
      image.src = variantImage;
      image.removeAttribute('srcset');
    }
  });

  document.addEventListener('keydown', (event) => {
    const tabButton = event.target.closest('[data-hh-tab-button]');

    if (!tabButton) return;

    const section = tabButton.closest('[data-hh-product-tabs]');
    const buttons = Array.from(section.querySelectorAll('[data-hh-tab-button]'));
    const currentIndex = buttons.indexOf(tabButton);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = buttons.length - 1;

    if (nextIndex !== currentIndex) {
      event.preventDefault();
      buttons[nextIndex].focus();
      buttons[nextIndex].click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-support-center"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hh-support').forEach((supportCenter) => {
    const search = supportCenter.querySelector('.hh-support__faq-search');
    const items = [...supportCenter.querySelectorAll('[data-support-faq]')];
    const empty = supportCenter.querySelector('.hh-support__faq-empty');

    if (!search || !items.length || !empty) return;

    search.addEventListener('input', () => {
      const query = search.value.trim().toLocaleLowerCase();
      let matches = 0;

      items.forEach((item) => {
        const visible = !query || item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !visible;
        if (visible) matches += 1;
      });

      empty.hidden = matches !== 0;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
